import { createVuetify } from 'vuetify'
import { pt, en } from "vuetify/locale";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";

const current = navigator.language.split("-")[0];

export const vuetify = createVuetify({
	lang: { locales: { pt, en }, current: "pt" },
	current,
	options: {
		customProperties: true,
	},
	locale: {
		locale: "pt",
	},
	date: {
		locale: {
			pt: "pt-BR"
		},
	},
	defaults: {
		global: {
			hideDetails: "auto",
		},
		VMaskInput: {
			density: "comfortable",
			variant: "outlined",
			bgColor: "background"
		},
		VTextField: {
			density: "comfortable",
			variant: "outlined",
			bgColor: "background"
		},
		VTextarea: {
			density: "comfortable",
			variant: "outlined",
			bgColor: "background"
		},
		VCombobox: {
			density: "comfortable",
			variant: "outlined",
			bgColor: "background"
		},
		VDatePicker: {
			header: "Selecione a data",
			hideTitle: true,
			showAdjacentMonths: true,
		}
	},
	theme: {
		defaultTheme: "light",
		themes: {
			light: {
				dark: false,
				colors: {
					background: "#FAFCFF",
					main: "#718096",
					primaryDarker: "#23083C",
					primaryDark: "#26235E",
					primary: "#1e3b73",
					primaryAlt: "#472F92",
					primaryLight: "#A582CA",
					secondaryLight: "#F8A07C",
					secondary: "#e5e9f2",
					secondaryDark: "#B95827",
					accent: "#e5e7eb",
					error: "#ae3535",
					danger: "#9E0833",
					info: "#0ea5e9",
					success: "#456934",
					blackAlpha500: "#b4b4b4",
					black: "#1A202C",
					white: "#FFFFFF",
					gray50: "#F7FAFC",
					gray100: "#EDF2F7",
					gray200: "#E2E8F0",
					gray300: "#CBD5E0",
					gray400: "#A0AEC0",
					gray500: "#718096",
					gray600: "#4A5568",
					gray700: "#2D3748",
					textoVueSwal: "#1A202C",
					backGroundVueSwal: "#F7FAFC",
					whatsapp: "#00FF38",
					colorfulBackground: "#1e3b73",
					backgroundCard: "#e5e9f2",
					backgroundCardDark: "#C1CEE8",
					defaultFontColor: "#1A202C",
					situacaoRascunho: "#667185",
					situacaoProtocolada: "#8E98A8",
					situacaoEmAnalise: "#1e3b73",
					situacaoPendente: "#975229",
					situacaoRetornoPendencia: "#3160ba",
					situacaoCadastrada: "#456934",
					situacaoIndeferida: "#4a1c1a",
					situacaoCancelada: "#ae3535",
					situacaoEncerrada: "#1b4332",
					filled: "#d5dbe6",
					paginationColor: "#1e3b73",
				},
				variables: {
					"disabled-opacity": 0.65,
				}
			},
			dark: {
				dark: true,
				colors: {
					background: "#2C2C2E",
					primary: "#1e3b73",
					secondary: "#36383d",
					accent: "#334155",
					error: "#c74646",
					danger: "#9E0833",
					info: "#0ea5e9",
					success: "#456934",
					warning: "#FF5C00",
					blackAlpha500: "#b4b4b4",
					black: "#fdfdff",
					white: "#fdfdff",
					gray50: "#2D3748",
					gray100: "#4A5568",
					gray200: "#718096",
					gray300: "#A0AEC0",
					gray400: "#CBD5E0",
					gray500: "#E2E8F0",
					gray600: "#EDF2F7",
					gray700: "#F7FAFC",
					textoVueSwal: "#FFFFFF",
					backGroundVueSwal: "#1E1E1E",
					colorfulBackground: "#1e3b73",
					backgroundCard: "#36383d",
					backgroundCardDark: "#52555E",
					defaultFontColor: "#F7FAFC",
					situacaoRascunho: "#a3a9b6",
					situacaoProtocolada: "#7e7f81",
					situacaoEmAnalise: "#4c7cd6",
					situacaoPendente: "#cc7847",
					situacaoRetornoPendencia: "#4c7cd6",
					situacaoCadastrada: "#598544",
					situacaoIndeferida: "#996361",
					situacaoCancelada: "#c74646",
					situacaoEncerrada: "#5bae8b",
					filled: "#464950",
					paginationColor: "#fdfdff",
				},
				variables: {
					"disabled-opacity": 0.65,
				}
			},
		},
	},
	components,
	directives,
});

export default vuetify;
